import { useQuery } from 'react-query';

import {
  savedMessagesRoute,
  savedMessagesKey,
  SavedMessage,
  savedNotesKey,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';

type useGetSavedMessagesProps = {
  enabled: boolean;
  isNote?: boolean
};

export const useGetSavedMessages = ({ enabled, isNote }: useGetSavedMessagesProps) => {
  const { data: savedMessages } = useQuery<{ object?: SavedMessage[] }>(
    [isNote ? savedNotesKey : savedMessagesKey],
    {
      enabled: enabled,
      queryFn: () =>
        axiosInstance.get(savedMessagesRoute + (isNote ? '?is_note=true' : '')).then((res) => res.data),
      refetchOnWindowFocus: false,
    },
  );

  return {
    savedMessages,
  };
};
